import type { AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';

const topicRedirection = (
  topicId: number,
  userCity: number,
  userCountry: number,
  dataUserType: string,
) =>
  dataUserType === 'close'
    ? Routes.topic_members_index_path(topicId, {
        city: userCity,
        country: userCountry,
      })
    : Routes.topic_members_index_path(topicId);

const networkRedirection = (
  userCity: number,
  userCountry: number,
  dataUserType: string,
) =>
  dataUserType === 'close'
    ? Routes.people_path({
        city: userCity,
        country: userCountry,
      })
    : Routes.people_path({});

export const getRedirectionUrl = (
  ids: AuthenticationIds,
  dataUserType: string,
) =>
  !ids.userCity || !ids.userCountry
    ? ''
    : ids?.topic
    ? topicRedirection(ids.topic, ids.userCity, ids.userCountry, dataUserType)
    : networkRedirection(ids.userCity, ids.userCountry, dataUserType);
